import jwtDecode from "jwt-decode";

const ROLES = {
    admin: {
        partner: {
            view: true,
            update: true,
            create: true,
            delete: true,
        },
        companyGroup: {
            view: true,
            update: true,
            create: true,
            delete: true,
        },
        savedCommission: {
            view: true,
            update: true,
            create: true,
            delete: true,
        },
        customUser: {
            view: true,
            update: true,
            create: true,
            delete: true,
        },
        report: {
            view: true,
            update: true,
            create: true,
            delete: true,
        },
        generalLedgerAnalytics: {
            view: true,
            update: true,
            create: true,
            delete: true,
        },

    },
    sales: {
        savedCommission: {
            view: true,
            update: false,
            create: false,
            delete: false,
        }
    }
}

const hasPermission = (auth, resource, action, data) => {
    if (!resource) return true
    const user = jwtDecode(auth?.access)
    const role = user.role
    if (!role) return false
    const permission = ROLES[role]?.[resource]?.[action]
    if (permission == null) return false;
    if (typeof permission === "boolean") return permission;
    return data != null && permission(user, data);
}

export {hasPermission}